import React from 'react';

// Size configurations
const sizeConfig = {
  small: {
    icon: 'h-6',
    text: 'text-base',
    spacing: 'space-x-2',
    full: 'h-8'
  },
  medium: {
    icon: 'h-8',
    text: 'text-xl',
    spacing: 'space-x-3',
    full: 'h-10'
  },
  large: {
    icon: 'h-10 md:h-12',
    text: 'text-xl md:text-2xl',
    spacing: 'space-x-3',
    full: 'h-12 md:h-16'
  }
};

// Symbol color configurations
const symbolColorConfig = {
  white: '/logos/simbolo-blanco.png',
  blue: '/logos/simbolo-azul.png',
  default: '/logos/simbolo.png'
};

// Full logo color configurations
const fullLogoColorConfig = {
  white: '/logos/logo-blanco-variacion.png',
  blue: '/logos/logo-azul.png',
  default: '/logos/logo-png.png'
};

const Logo = ({
  size = 'medium',
  color = 'white',
  textColor = 'white',
  variant = 'symbol', // 'symbol' or 'full'
  className = '',
  showText = true
}) => {
  const config = sizeConfig[size] || sizeConfig.medium;
  
  // If variant is 'full', use full logo, otherwise use symbol
  const isFullLogo = variant === 'full';
  const logoPath = isFullLogo 
    ? (fullLogoColorConfig[color] || fullLogoColorConfig.white)
    : (symbolColorConfig[color] || symbolColorConfig.white);

  // If using full logo, just render the image
  if (isFullLogo) {
    return (
      <div className={className}>
        <img 
          src={logoPath}
          alt="Rokwansoft Logo" 
          className={`${config.full} object-contain`}
        />
      </div>
    );
  }

  // Otherwise, render symbol + text
  return (
    <div className={`flex items-center ${config.spacing} ${className}`}>
      <div className="flex items-center justify-center">
        <img 
          src={logoPath}
          alt="Rokwansoft Symbol" 
          className={`${config.icon} object-contain`}
        />
      </div>
      {showText && (
        <div 
          className={`${config.text} font-bold uppercase leading-tight`} 
          style={{ 
            fontFamily: "'Corpline', sans-serif",
            color: textColor
          }}
        >
          <div>ROKWAN</div>
          <div>SOFT</div>
        </div>
      )}
    </div>
  );
};

export default Logo;

